import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { Container as ContainerBase } from "components/misc/Layouts.js";
import logo from "../../images/logo.PNG";
import { ReactComponent as FacebookIcon } from "../../images/facebook-icon.svg";
import { ReactComponent as InstagramIcon } from "../../images/instagram-icon.svg";
import AnchorLink from "react-anchor-link-smooth-scroll";

const Container = tw(ContainerBase)`bg-gray-900 text-gray-100 -mx-8 -mb-8`;
const Content = tw.div`max-w-screen-xl mx-auto py-20 lg:py-24`;

const Row = tw.div`flex items-center justify-center flex-col px-8`;

const LogoContainer = tw.div`flex items-center justify-center md:justify-start`;
const LogoImg = tw.img`w-16`;

const LinksContainer = tw.div`mt-8 font-medium flex flex-wrap justify-center items-center flex-col sm:flex-row`;
const Link = tw(
    AnchorLink
)`border-b-2 border-transparent hocus:text-gray-300 hocus:border-gray-300 pb-1 transition duration-300 mt-2 mx-4`;

const SocialLinksContainer = tw.div`mt-10`;
const SocialLink = styled.a`
    ${tw`cursor-pointer inline-block text-gray-100 hover:text-gray-500 transition duration-300 mx-4`}
    svg {
        ${tw`w-5 h-5`}
    }
`;

const CopyrightText = tw.p`text-center mt-10 font-medium tracking-wide text-sm text-gray-600`;
export default () => {
    return (
        <Container>
            <Content>
                <Row>
                    {/* <LogoContainer>
                        <LogoImg src={logo} />
                    </LogoContainer> */}
                    <LinksContainer>
                        <Link href="#nosotros">Nosotros</Link>
                        <Link href="#productos">Productos</Link>
                        <Link href="#contacto">Contacto</Link>
                    </LinksContainer>
                    <SocialLinksContainer>
                        <SocialLink
                            href="https://www.facebook.com/p/Mylen-100091701999105/"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <FacebookIcon />
                        </SocialLink>
                        <SocialLink
                            href="https://www.instagram.com/panificadosmylen/"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <InstagramIcon />
                        </SocialLink>
                    </SocialLinksContainer>
                    <CopyrightText>
                        &copy; 2025 Panificados Mylen. Todos los derechos reservados. <br />
                        Elaboramos con tiempo, dedicación y mucho amor.
                    </CopyrightText>
                </Row>
            </Content>
        </Container>
    );
};
